// 預期工時表
import * as types from '../actionType';

let initState = [];

function expectdWorkState(state = initState, action) {
  switch (action.type) {
      case types.EXPECTED_WORK_SHEET_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default expectdWorkState;